type IconProps = {
  className?: string;
};

export const LocationFooterIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0C5.425 0 0.5 4.925 0.5 11C0.5 18.234 7.652 21.697 8.548 22.503C9.463 23.326 10.219 25.171 10.524 26.217C10.672 26.725 11.088 26.982 11.5 26.993C11.913 26.981 12.328 26.724 12.476 26.217C12.781 25.171 13.537 23.327 14.452 22.503C15.348 21.697 22.5 18.234 22.5 11C22.5 4.925 17.575 0 11.5 0ZM11.5 14C9.843 14 8.5 12.657 8.5 11C8.5 9.343 9.843 8 11.5 8C13.157 8 14.5 9.343 14.5 11C14.5 12.657 13.157 14 11.5 14Z"
      fill="currentColor"
    />
  </svg>
);
